import { render, staticRenderFns } from "./MoveSortActions.vue?vue&type=template&id=0a93165a&scoped=true&"
import script from "./MoveSortActions.vue?vue&type=script&lang=js&"
export * from "./MoveSortActions.vue?vue&type=script&lang=js&"
import style0 from "./MoveSortActions.vue?vue&type=style&index=0&id=0a93165a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a93165a",
  null
  
)

export default component.exports